import React, { Component } from 'react'
import {axisBottom} from 'd3-axis';
import {format} from "d3-format";
import {select} from 'd3-selection';

class YearXAxis extends Component {

  renderAxis() {
    const {formatters, x, inner_height, svg_height, margins} = this.props
    var xAxis = axisBottom()
      .scale(x)
      .ticks(6)
      .tickSize(- inner_height, 0 ,0)
      .tickFormat(format("d"));
    const node = this.refs.axis;
    const axis = select(node).call(xAxis);
    axis.selectAll("line")
      .attr("transform", `translate(${x(2011)/2},0)`)
    axis.selectAll("text")
      .attr("y", 10)
      .attr("x", x(2011)/2)
      .attr("text-anchor", "middle")
  }

  componentDidMount() {
    this.renderAxis();
  }

  componentDidUpdate() {
    this.renderAxis();
  }

  render() {
    const {margins} = this.props;
    return (
      <g className="Axis no-ticks" ref="axis" transform={`translate(0,${this.props.inner_height})`}>
      </g>
    )
  }
}

export default YearXAxis;



/** WEBPACK FOOTER **
 ** ./src/components/YearXAxis.js
 **/